<template>
    <div class="min-h-screen bg-default">
        <PLoading :loading="loading" />
        <!-- topo só no mobile: no desktop a navegação vive na sidebar -->
        <header class="lg:hidden dark bg-default border-b border-default sticky top-0 z-50 h-(--ui-header-height)">
            <LayoutNav />
        </header>
        <div class="flex">
            <!-- sidebar sempre escura (classe `dark`): os tokens dos filhos resolvem no tema escuro -->
            <aside
                class="dark hidden lg:flex lg:flex-col w-56 shrink-0 lg:sticky lg:top-0 lg:h-screen overflow-y-auto bg-default border-r border-default px-3 py-6">
                <div class="px-3 pb-6">
                    <LayoutLogo />
                </div>
                <LayoutMenu />
                <div class="mt-auto px-3 pt-6 flex flex-col gap-3 items-start">
                    <UPopover>
                        <UTooltip text="Aparência">
                            <UButton icon="i-solar-palette-linear" variant="ghost" color="neutral" size="sm"
                                label="Aparência" />
                        </UTooltip>
                        <template #content>
                            <div class="p-4">
                                <SettingsColor />
                            </div>
                        </template>
                    </UPopover>
                    <p class="text-[11px] text-dimmed leading-relaxed">Portal interno · Leadins</p>
                </div>
            </aside>
            <main class="flex-1 min-w-0 pb-24">
                <slot />
            </main>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    }
})
</script>
